import $ from "jquery";
import modalCart from "./../modals/modalCart";
import modalSearch from "./../modals/modalSearch";
import modalLogin from "./../modals/modalLogin";

const callModal = {
  "modal-cart": ([newProduct, open]) => modalCart.call(newProduct, open),
  "modal-search": () => modalSearch.call(),
  "modal-login": (source) => modalLogin.call(source),
};

const openLoginIfUrl = () => {
  if (window.location.hash === "#modal-login") {
    const getLocation = window.location.href.replace("#modal-login", "");
    modalLogin.call();
    window.history.pushState("", "", `${getLocation}`);
  }
};

const modals = () => {
  const documentHandler = (event) => {
    if (event.keyCode === 27) {
      close();
    }
  };

  const close = () => {
    $(".modal").fadeOut(300);
    $("html").removeClass("overflow");
    document.removeEventListener("click", documentHandler, false);
  };

  const open = (target, src, targetAttr) => {
    if (target.length) {
      $(".modal").fadeOut(300);
      $("html").addClass("overflow");

      if (src) {
        target.find(".js-preview-image").attr("src", src);
      } else if (targetAttr === "modal-cart" && !target.hasClass("active")) {
        callModal[targetAttr]([false, true])
      }
      target.fadeIn(300);
      if (targetAttr === "modal-search") {
        $("#modal-search-input").focus();
      } else if (targetAttr === "modal-login") {
        $("#modal-login-tel").focus();
      }
      document.addEventListener("keyup", documentHandler, false);
    }
  };

  $(document)
    .on("click", ".modal-btn", function openModal(e) {
      e.preventDefault();

      const $this = $(this);
      const target = $this.attr("data-target");
      const targetModal = $(`.modal[data-target='${target}']`);
      let src = "";
      let params = "";

      if (target === "modal-cart") {
        params = [false, true];
      } else if (target === "modal-login") {
        params = $this.attr("data-ga");
      }

      if (!targetModal.length || target === "modal-credit") {
        callModal[target](params);
      } else {
        open(targetModal, src, target);
      }
    })
    .on("click", ".modal", (event) => {
      const { target } = event;

      if (
        !$(target).closest(".modal-content, .js_favorite_modal_content")
          .length ||
        $(target).hasClass("js-close") ||
        $(target).closest(".js-close").length
      ) {
        close();
      }
    });
};

openLoginIfUrl();

export default modals;
